/* 🤖 this file was generated by svg-to-ts */
export const siriusCaretLeftSmall: {
  name: 'caret_left_small';
  data: string;
} = {
  name: 'caret_left_small',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.217 16.468a.75.75 0 0 1-1.06 0L10.22 12.53a.75.75 0 0 1 0-1.06l3.936-3.938a.75.75 0 1 1 1.06 1.06L11.812 12l3.406 3.407a.75.75 0 0 1 0 1.06Z" fill="currentColor"/></svg>`
};
